{
  "HELP": "Obtener ayuda",
  "TERMS_CONDITIONS": "Términos y Condiciones",
  "PRIVACY": "Política de Privacidad",
  "REVOLUPAY_INFO": "<0>REVOLUPAY EP S.L. Entidad de Pagos autorizada y supervisada por el Banco de España e inscrita en el Registro de Entidades con código 6900. RevoluPAY es una empresa española perteneciente al grupo <1>REVOLUGROUP CANADA INC </1><3>(TSX.V = REVO).</3></0>",
  "LOADING": "Cargando...",
  "CANCEL": "CANCELAR",
  "CONFIRM": "CONFIRMAR"
}